import { getFirstLastMsgIndicesFromSummaryMetadata } from '@modules/feedback/components/AudioType/utils';
import { SummaryMetadata } from 'generated/graphql';

export const isKeywordSummaryAudioBeingPlayed = (
  metadata: SummaryMetadata | undefined,
  currentlyPlayingMsgIndex: number,
): boolean => {
  const { firstMsgIndex, lastMsgIndex } =
    getFirstLastMsgIndicesFromSummaryMetadata(metadata);

  return (
    currentlyPlayingMsgIndex >= firstMsgIndex &&
    currentlyPlayingMsgIndex <= lastMsgIndex
  );
};
